const computeForceRating = (boughtTalents, { universalForce, careerHasFR, shortPath } = {}) => {
    const bt = boughtTalents || [];
    const witchcraft = bt.some((t) => t.key === "WITCHCCOTR");
    const forceRat = bt.find((t) => t.key === "FORCERAT");
    const customFR = bt.reduce((sum, t) => {
        if (t.key === "WITCHCCOTR" || t.key === "FORCERAT") { return sum; }
        return sum + (parseInt(t.data?.Attributes?.ForceRating) || 0) * (t.count || 1);
    }, 0);

    const specForce = universalForce === 1 || !!careerHasFR || witchcraft;
    if (!specForce && customFR <= 0) { return 0; }

    let FR = specForce ? 1 : 0;
    if (shortPath) { FR += 1; }
    if (forceRat) { FR += (parseInt(forceRat.count) || 0); }
    FR += customFR;
    return FR;
};

export default computeForceRating;
